import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-four-lesson-four-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitFourLessonFourGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 4, Lesson 4 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 4: The Job Application Process";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
